import { css } from 'styled-components';
import { hasValue, getProperty } from '@famly/vet_ts-utils_typescript';
export const defaultElevationConfiguration = {
    one: 'none',
    two: 'none',
    three: 'none',
    four: 'none',
    five: 'none',
    six: 'none',
};
export const elevationCSS = css `
    ${props => hasValue(props.elevation) && hasValue(getProperty(props.theme.elevation, props.elevation))
    ? css `
                  box-shadow: ${props.theme.elevation[props.elevation]};
              `
    : ''}
`;
